import React from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, FormControl, FormControlLabel, Grid } from "@mui/material";
import { InputLabel } from "common/styles/muiStyled";

interface Props {
  domainUrl: string;
  onChange: (checked: boolean, termName: string) => void;
  isDelegateCustomerType?: boolean;
}

const Terms: React.FC<Props> = ({ domainUrl, onChange, isDelegateCustomerType }) => {
  const { t } = useTranslation('common');

  const termsContent =
    <>
      {t("badgeForm.termsContentPart1")}&nbsp;
      <a href={`${domainUrl}registrationtc.html`} target="_blank" rel="noopener noreferrer">
        {t("badgeForm.termsContentPart2")}
      </a>
      &nbsp;{t("badgeForm.termsContentPart3")}
    </>;

  return (
    <Grid item xs={12} sx={{ pt: 3 }} >
      <FormControl variant="standard" sx={{ width: "100%", mt: 1.5 }}>
        <InputLabel sx={{ pb: 2 }}>
          {t("badgeForm.terms")}
        </InputLabel>
        <FormControlLabel
          control={<Checkbox name="acceptedTerms" />}
          label={termsContent}
          onChange={(_, checked) => onChange(checked, 'mainTerm')}
          componentsProps={{
            typography: { fontSize: 14, ml: 1 }
          }}
          sx={{ m: 0, alignItems: "flex-start", cursor: "default" }}
        />
        {isDelegateCustomerType &&
          <FormControlLabel
            control={<Checkbox name="acceptedTerms" data-testid="delegate-terms-checkbox" />}
            label={<>{t("badgeForm.delegateContent")}</>}
            onChange={(_, checked) => onChange(checked, 'delegateTerm')}
            componentsProps={{
              typography: { fontSize: 14, ml: 1 }
            }}
            sx={{ m: 0, alignItems: "flex-start", cursor: "default", marginTop: 2 }}
          />
        }
      </FormControl>
    </Grid>
  );
};

export default Terms;
